import React, { useCallback } from "react";

import { TextData } from "lib/models";
import TextEditor from "components/TextEditor";
import { updateEntry } from "lib/api";


interface TextEditorProps {
  uuid: string;
  data: TextData;
  readOnly?: boolean;
};


const TextEntryEditor = ({uuid, data, readOnly}: TextEditorProps) => {

  const saveText = useCallback(async (updatedText: string): Promise<void> => {
    const updatePatch: Partial<TextData> = {text: updatedText};
    await updateEntry(uuid, data.type, updatePatch);
    data.text = updatedText;
  }, [uuid, data.type]);

  return (
    <TextEditor
      initialText={data.text}
      onChangeThrottled={saveText}
      readOnly={readOnly}
    />
  );
};

export default TextEntryEditor;
